import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  container: {
    padding: 24,
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  col: {
    flex: 1,
  },
});

export default styles;
